<template>
  <div style="width: 72px;" class="d-flex justify-content-between">
      <span class="en-linea">
        <CampoIndicadorEstadoSii :documento="documento"/>
      </span>
    <span class="en-linea">
      <CampoIndicadorEstadoComercial :documento="documento" />
    </span>
  </div>
</template>

<script>
import CampoIndicadorEstadoSii from './CampoIndicadorEstadoSii';
import CampoIndicadorEstadoComercial from './CampoIndicadorEstadoComercial';

export default {
  name: 'CampoEstadosEmision',
  components: { CampoIndicadorEstadoSii, CampoIndicadorEstadoComercial },
  props: {
    documento: {
      type: Object,
    },
  }
};
</script>

<style scoped>
.en-linea {
  display: inline-block !important;
  margin-left: 3px !important;
  cursor: pointer;
}
</style>
